var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cw-about-us"},[_vm._v("\n\t\t关于我们\n  \t")])}
var staticRenderFns = []

export { render, staticRenderFns }